export enum FormControlLabelStateClass {
	Default = 'a-label js-form__label' as any,
	Required = 'state-a-label--is-required' as any,
	Floated = 'state-a-label--is-floated' as any,
	DoNotRemoveFloated = 'state-a-label--do-not-remove' as any,
}

export const FormControlSiteCoreStateClass: string = 'input-validation-error';

// use js-form_label selector, inform BE
export function getLabel(control: HTMLElement) {
	const $this = $(control);
	const placeholderTxt = $this.attr('placeholder');
	let $label = $this.prev('label');

	// As discussed with design, there should be no placeholder when it is clicked end empty
	// because a placeholder can't be removed in all browsers via css, it has to be done with js.
	// Therefore => if there is only a placeholder, transform it to a label.
	if ($label.length === 0 && placeholderTxt) {
		$this.attr('placeholder', '');
		$label = $(`<label class="${FormControlLabelStateClass.Default}">${placeholderTxt}</label>`);
		$this.before($label);
	} else if ($label.length > 0 && placeholderTxt) {
		$this.attr('placeholder', '');
	}

	if ($this.attr('data-val-required')) {
		$label.addClass(FormControlLabelStateClass.Required.toString());
	}

	if (!$label.hasClass(FormControlLabelStateClass.Default.toString())) {
		$label.addClass(FormControlLabelStateClass.Default.toString());
	}

	return $label;
}

export function floatControlLabel(control: HTMLElement, isFocused: boolean = false) {
	const $formControl = $(control);

	if ($formControl.length) {
		$formControl.each(function() {
			const $this = $(this);
			const $label = getLabel(control);

			if ($label && $this) {
				// enables floating label also for disabled selected options
				const value =
					this instanceof HTMLSelectElement && !$this.val()
						? $this.find('option[selected]').attr('value')
						: $this.val();

				if ((value && value.toString().length > 0) || isFocused) {
					$label.addClass(FormControlLabelStateClass.Floated.toString());
					let $innerWidth;
					if ($this.hasClass('select2-hidden-accessible')) {
						$innerWidth = $this.next('.select2').innerWidth();
					} else {
						$innerWidth = $this.innerWidth();
					}
					if ($innerWidth) {
						$label.css('max-width', `${Math.floor($innerWidth) - 30}px`);
					}
				} else {
					if ($label.hasClass(FormControlLabelStateClass.DoNotRemoveFloated.toString())) {
						$label.css('max-width', 'none');
					} else {
						$label.removeClass(FormControlLabelStateClass.Floated.toString());
						$label.css('max-width', 'none');
					}
				}

				if (isFocused) {
					const $innerWidth = $this.innerWidth();
					if ($innerWidth) {
						$label.css('max-width', $innerWidth - 30 + 'px');
					}
				}

				// @ts-ignore
				$this.on('blur', (ev: Event) => {
					isFocused = false;
					if (!$this.val()) {
						$label.removeClass(FormControlLabelStateClass.Floated.toString());
					}
				});
			}
		});
	}
}

export default {
	floatControlLabel,
	FormControlLabelStateClass,
	FormControlSiteCoreStateClass,
};
